import { render, staticRenderFns } from "./self-change-ticket-list.vue?vue&type=template&id=73113858"
import script from "./self-change-ticket-list.vue?vue&type=script&lang=js"
export * from "./self-change-ticket-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports